import { c as _c } from "react/compiler-runtime";
import { useDesignContext } from '@systemeio/digital-store-shared';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { SecondaryButton } from '@systemeio/ui';
import { StoreFontPicker } from 'modules/stores/store/components/design/store-font-picker';
import PreviewBox from 'modules/stores/store/components/preview-box';
import React, { Fragment, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { useStore } from '../hooks/use-store';
import { useStoreQuery } from '../hooks/use-store-query';
import { StoreThemeColorPicker } from './design/store-theme-color-picker';
import { StoreThemeSaveButton } from './design/store-theme-save-button';
import { EyeIcon } from '@systemeio/ui/icons';
const PreviewBoxMobile = t0 => {
  const $ = _c(37);
  const {
    title,
    icon,
    className,
    showOnlyCloseButton: t1
  } = t0;
  const showOnlyCloseButton = t1 === undefined ? false : t1;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    storeId
  } = useStoreQuery();
  const {
    data: store
  } = useStore(storeId);
  const {
    setState
  } = useDesignContext();
  let t2;
  if ($[0] !== setState || $[1] !== store) {
    t2 = () => {
      store && setState(store.design);
    };
    $[0] = setState;
    $[1] = store;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const afterLeave = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpened(false);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClose = t3;
  let t4;
  if ($[4] !== className) {
    t4 = twMerge("flex lg:hidden", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== opened) {
    t5 = () => setOpened(!opened);
    $[6] = opened;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== icon) {
    t6 = icon === undefined && <EyeIcon className="fill-text-primary group-hover:fill-background-secondary main-transition-colors" />;
    $[8] = icon;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== icon || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== title) {
    t7 = <SecondaryButton className={t4} onClick={t5}>{t6}{icon}{title}</SecondaryButton>;
    $[10] = icon;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TransitionChild as={Fragment} enter="duration-300 ease-out" enterFrom="opacity-0" enterTo="opacity-100" leave="duration-200 ease-in" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/25" /></TransitionChild>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <PreviewBox />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== showOnlyCloseButton) {
    t10 = !showOnlyCloseButton && <div className="flex flex-col items-start gap-3"><StoreThemeColorPicker /><StoreFontPicker /></div>;
    $[18] = showOnlyCloseButton;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== showOnlyCloseButton) {
    t11 = !showOnlyCloseButton && <StoreThemeSaveButton className="w-full" />;
    $[20] = showOnlyCloseButton;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("global.close");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <SecondaryButton className="w-full" onClick={handleClose}>{t12}</SecondaryButton>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t13) {
    t14 = <Dialog as="div" className="relative z-50" onClose={handleClose}>{t8}<div className="fixed inset-x-0 bottom-0 h-full"><div className="flex h-full min-h-full items-center justify-center text-center"><TransitionChild as={Fragment} enter="transition duration-300 ease-in-out transform" enterFrom="transform translate-y-full" enterTo="transform translate-y-0" leave="transition duration-300 ease-in-out transform" leaveFrom="transform translate-y-0" leaveTo="transform translate-y-full"><DialogPanel className="bg-background-primary flex h-full w-full transform select-none justify-center overflow-hidden p-5 text-left align-middle shadow-xl"><div className="flex h-full w-fit flex-col items-center justify-center gap-3">{t9}{t10}{t11}{t13}</div></DialogPanel></TransitionChild></div></div></Dialog>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== afterLeave || $[31] !== opened || $[32] !== t14) {
    t15 = <Transition appear={true} show={opened} as={Fragment} afterLeave={afterLeave}>{t14}</Transition>;
    $[30] = afterLeave;
    $[31] = opened;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15 || $[35] !== t7) {
    t16 = <>{t7}{t15}</>;
    $[34] = t15;
    $[35] = t7;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default PreviewBoxMobile;